// Maps Russian colour names (as stored on products) to a swatch hex, shared by
// the seller console and the buyer app so colour chips render identically in
// both. `colorDot` falls back to a neutral slate for any unmapped colour name.
export const COLOR_DOTS: Record<string, string> = {
  Белый: "#ffffff",
  Чёрный: "#1a1a1a",
  Красный: "#dc2626",
  Синий: "#2563eb",
  Зелёный: "#16a34a",
  Бежевый: "#e7d5b9",
  Коричневый: "#8b5e3c",
  Серый: "#9ca3af",
  Розовый: "#f9a8d4",
  Голубой: "#93c5fd",
  Серебряный: "#d1d5db",
  Золотой: "#facc15",
  Фиолетовый: "#a855f7",
  Натуральный: "#dbcaae",
  Жёлтый: "#facc15",
  Прозрачный: "#e5e7eb",
  Оранжевый: "#fb923c",
}

export const colorDot = (label: string): string => COLOR_DOTS[label] ?? "#cbd5e1"
